import Navbar from './Navbar';
import MobileNav from "./MobileNav";
import { Link } from "react-router-dom";
import '../site.css';
import './Menu.css';


const Header = () => {
    return (
        <header>
            <div className="nav-area">
                <Link to="/" className="logo">
                    <span>Kanall&ouml;pet</span>
                </Link>
                <Navbar/>
                <MobileNav/>
            </div>
        </header>
    );
};

export default Header;